import { rem } from 'polished'
import type { ComponentProps } from 'react'
import { forwardRef } from 'react'
import styled from 'styled-components'
import BodyText from '../Typography/BodyText'
import CheckboxButton from './CheckboxButton'
import clsx from 'clsx'

const Label = styled.label<{ $hideCheckbox?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${props => props.$hideCheckbox ? 0 : rem(12)};
  cursor: ${props => props.$hideCheckbox ? 'pointer' : 'default'};
`

const LabelText = styled(BodyText)`
  flex-grow: 1;
  transition: color 0.2s;
`

interface Props extends ComponentProps<typeof CheckboxButton> {
}

/**
 * Checkbox input with a label.
 *
 * For the checkbox input without the label see `<CheckboxButton>`
 */
const CheckboxInput = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const { children, className, size = 'medium', hideCheckbox, ...inputProps } = props

  return <Label
    className={clsx(className, `size-${size}`)}
    htmlFor={inputProps.id}
    title={inputProps.title}
    $hideCheckbox={hideCheckbox}
  >
    <CheckboxButton {...inputProps} ref={ref} size={size} hideCheckbox={hideCheckbox} />
    <LabelText
      colour={inputProps.disabled ? 'neutral-four' : 'neutral-one'}
      variant={size}
      forwardedAs="span"
    >
      {children}
    </LabelText>
  </Label>
})

export default CheckboxInput
